import format from "./format";

export default {
  mixins: [format],

  methods: {
    jobNumber() {
      return `#${this.activity.job_id}J`;
    },

    appointmentNumber() {
      if (this.$lodash.has(this.activity, "detail.appointment.appointment_number")) {
        return this.activity.detail.appointment.appointment_number;
      }

      return null;
    },

    appointmentAssistants() {
      return this.$lodash.get(this.activity, "detail.appointment.assistants", []);
    },

    appointmentAssistantName() {
      return this.$lodash.get(this.activity, "detail.appointment.assistant.name", "Assistant");
    },

    appointmentTechnicianName() {
      return this.$lodash.get(this.activity, "detail.appointment.user.name", "Technician");
    },

    appointmentAssistantProfile() {
      let html = "";

      if (this.$lodash.has(this.activity, "detail.appointment.assistant.email")) {
        html += `Email: ${this.activity.detail.appointment.assistant.email}<br>`;
      }

      if (this.$lodash.has(this.activity, "detail.appointment.assistant.mobile")) {
        html += `Mobile: ${this.activity.detail.appointment.assistant.mobile}<br>`;
      }

      return html;
    },

    appointmentTechnicianProfile() {
      let html = "";

      if (this.$lodash.has(this.activity, "detail.appointment.user.email")) {
        html += `Email: ${this.activity.detail.appointment.user.email}<br>`;
      }

      if (this.$lodash.has(this.activity, "detail.appointment.user.mobile")) {
        html += `Mobile: ${this.activity.detail.appointment.user.mobile}<br>`;
      }

      return html;
    },

    appointmentTime() {
      return this.formatLocalDate(
        this.$lodash.get(this.activity, "detail.appointment.time"),
        "Do MMM@hh:mma"
      );
    },

    appointmentDuration() {
      if (this.$lodash.has(this.activity, "detail.appointment.duration")) {
        const unit = this.activity.detail.appointment.duration === 1 ? "hour" : "hours";

        return `${this.activity.detail.appointment.duration} ${unit}`;
      }

      return null;
    },

    invoiceType() {
      return this.activity.detail.invoice.is_quote ? "Quote" : "Invoice";
    },

    invoiceTotal() {
      return `$${this.$lodash.get(this.activity, "detail.invoice.total")}`;
    },

    invoicePdf() {
      if (
        this.$lodash.has(this.activity, "detail.invoice.pdf") &&
        this.activity.detail.invoice.pdf !== null &&
        this.activity.detail.invoice.pdf.length > 0
      ) {
        return this.activity.detail.invoice.pdf;
      }

      return null;
    },

    invoicePaymentMethod() {
      if (this.$lodash.has(this.activity, "detail.method")) {
        return this.activity.detail.method;
      }

      return null;
    },

    customerName() {
      return this.$lodash.get(this.activity, "detail.customer.name", "Customer");
    },

    contactName() {
      return this.$lodash.get(this.activity, "detail.contact.name", "Customer");
    },

    customerProfile() {
      let html = "";

      if (this.$lodash.has(this.activity, "detail.customer.email")) {
        html += `Email: ${this.activity.detail.customer.email}<br>`;
      }

      if (this.$lodash.has(this.activity, "detail.customer.mobile")) {
        html += `Mobile: ${this.activity.detail.customer.mobile}<br>`;
      }

      return html;
    },

    contactProfile() {
      let html = "";

      if (this.$lodash.has(this.activity, "detail.contact.email")) {
        html += `Email: ${this.activity.detail.contact.email}<br>`;
      }

      if (this.$lodash.has(this.activity, "detail.contact.mobile")) {
        html += `Mobile: ${this.activity.detail.contact.mobile}<br>`;
      }

      return html;
    },

    userName() {
      return this.$lodash.get(this.activity, "detail.user.name", "User");
    },

    userProfile() {
      let html = "";

      if (this.$lodash.has(this.activity, "detail.user.email")) {
        html += `Email: ${this.activity.detail.user.email}<br>`;
      }

      if (this.$lodash.has(this.activity, "detail.user.mobile")) {
        html += `Mobile: ${this.activity.detail.user.mobile}<br>`;
      }

      return html;
    },

    messageContent() {
      return this.$lodash.get(this.activity, "detail.message").replace(/\n/g, "<br>");
    },

    formatId(id) {
      return `#${id.replace(/^0+/, "")}`;
    },

    openInNewTab(url) {
      window.open(url);
    },

    jobId() {
      return this.$lodash.get(this.activity, "job_id");
    },

    customerId() {
      if (this.$lodash.has(this.activity, "detail.customer.id")) {
        return this.$lodash.get(this.activity, "detail.customer.id");
      }

      return this.$lodash.get(this.activity, "detail.contact.customer_id");
    },

    appointmentAssistantId() {
      return this.$lodash.get(this.activity, "detail.appointment.assistant.id");
    },

    appointmentTechnicianId() {
      return this.$lodash.get(this.activity, "detail.appointment.user.id");
    },

    userId() {
      return this.$lodash.get(this.activity, "detail.user.id");
    },

    invoiceId() {
      return this.$lodash.get(this.activity, "detail.invoice.id");
    },
  },
};
